'use client';

import { usePartnerStackCookie } from '@/hooks/utils/usePartnerStackCookie';
import { useAppVersionCheck } from '@/utils/hooks/utils/useAppVersionCheck';
import { useUtmDataCookie } from '@/utils/hooks/utils/useUtmDataCookie';

type ClientProvidersProps = {
    children: React.ReactNode;
};

export function ClientProviders({ children }: ClientProvidersProps) {
    useUtmDataCookie();
    usePartnerStackCookie();
    useAppVersionCheck();

    return <>{children}</>;
}
